/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";
import { useNetworkStatus } from "config/hook";
import { useHistory } from "react-router-dom";

const NetworkError = () => {
	const classes = useStyles();
	const history = useHistory();
	const { isOnline } = useNetworkStatus();

	useEffect(() => {
		if (isOnline) {
			history.goBack();
		}
	}, [isOnline]);

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.bodyPage }}>
				<Grid style={{ textAlign: "center" }}>
					<img src={Images.networkError} alt="networkError" />
					<Grid classes={{ root: classes.text }}>
						Kết nối mạng của bạn có vấn đề. Vui lòng thử lại
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default memo(NetworkError);
